import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';

import { HeaderComponent } from '../header/header.component';

import { AdminHomepageComponent } from './admin-homepage/admin-homepage.component';
import { AdminKeywordsComponent } from './admin-keywords/admin-keywords.component';
import { AdminManualTriggersComponent } from './admin-manual-triggers/admin-manual-triggers.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [
    AdminKeywordsComponent,
    HeaderComponent,
    MatTabsModule,
    AdminHomepageComponent,
    AdminManualTriggersComponent
  ]
})
export class AdminComponent {}
